module.exports = __webpack_public_path__ + "media/images/menu-home-icon-76d9d255ed46716e733ba2955142edbc.svg";